const panels = document.querySelectorAll('.panel')

panels.forEach((panel) => {
    panel.addEventListener('click', () => {
        removeActiveClasses()
        panel.classList.add('active')
    })
});

function removeActiveClasses() {
    panels.forEach(panel => {
        panel.classList.remove('active')
    })
}

jQuery(document).ready(function($) {
   const options = {
       threshold: 0.5
   }
   const callback = (entries, observer) => {
       entries.forEach(entry => {
           if ( entry.isIntersecting ) {
               $(entry.target).find('.far-right, .far-left').addClass('active');
               observer.unobserve(entry.target);
           }
       });
   };
   const observer = new IntersectionObserver(callback, options);
   $('.sliding-section-row').each(function() {
       observer.observe(this);
   });


   $('body.home .iconic-events-carousel').slick({
       centerMode: true,
       centerPadding: '60px',
       slidesToShow: 3,
       prevArrow: null,
       nextArrow: null,
       responsive: [
           {
               breakpoint: 768,
               settings: {
                   arrows: false,
                   centerMode: true,
                   centerPadding: '60px',
                   slidesToShow: 7
               }
           },
           {
               breakpoint: 480,
               settings: {
                   arrows: false,
                   centerMode: true,
                   centerPadding: '40px',
                   slidesToShow: 1
               }
           }
       ]
   });
   $('body.home .page-content .wp-block-column:has(.projects-carousel)').addClass('has-projects-carousel');
   $('body.home .page-content .has-projects-carousel').prev().addClass('projects-carousel-column-title');
});

